// extracted by mini-css-extract-plugin
export default {"propertyNameText":"PropertyTable_propertyNameText__MUGjg","propertySortTableHeading":"PropertyTable_propertySortTableHeading__L+YCm"};